/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Result of the containment action
 * @export
 */
export const ControlResult = {
    Success: 'success',
    Pending: 'pending',
    Failure: 'failure'
} as const;
export type ControlResult = typeof ControlResult[keyof typeof ControlResult];


export function ControlResultFromJSON(json: any): ControlResult {
    return ControlResultFromJSONTyped(json, false);
}

export function ControlResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResult {
    return json as ControlResult;
}

export function ControlResultToJSON(value?: ControlResult | null): any {
    return value as any;
}

